// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var NotificationsController = function ($scope, Notifications, $http, PUtill, gettextCatalog, gettext, $routeParams, DatepickerUtils) {
    $scope.dateRange = { dateFrom: null, dateTo: null };
    
    //todo: think about retrieve notificationTypesEnum from api
    $scope.notificationTypesEnum = {
        'All': PUtill.getText('All'),
        'PaymentProviderBlocked': PUtill.getText('Payment Provider Blocked')        
    };

    $scope.notificationStatusEnum = {
        Closed: PUtill.getText('Resolved'),
        Unhandled: PUtill.getText('Unhandled'),
        Handled: PUtill.getText('Acknowledged')
    }; 

    function Column(text, isVisible, isSortable, field,filter, orderByField) {
        this.header = text;
        this.isVisible = isVisible;
        this.isSortable = isSortable;
        this.field = field;
        this.filter = filter;
        this.orderByField = orderByField;
        if (isSortable) {
            this.sortCriteria = 'Asc';
        }

        this.getCssClass = function() {
            if (this.isSortable) {
                if (this.sortCriteria === 'Asc') {
                    return 'icon-chevron-down';
                } else {
                    return 'icon-chevron-up';
                }
            }
        }
    }

    function Sort(field, direction) {
        this.propertyName = field;
        this.direction = direction;
    }

    $scope.columns = [
        new Column(gettext("Timestamp"), function (status) { return true; }, true, "StartTime",'pdate:medium',"_id"),
        new Column(gettext("End Time"), function (status) { return status == 'Closed'; }, false, "EndTime", 'pdate:medium'),
        new Column(gettext("Handled Time"), function (status) {return status == 'Handled';}, false, "HandledTime", 'pdate:medium'),
        new Column(gettext("Handled By"), function(status) {return status == 'Handled';}, false, "HandledUserName"),
        new Column(gettext("Event"), function (status) { return true; }, false, "ShortDescription"),
        new Column(gettext("Event Type"), function (status) { return true; }, false, "TypeName")
    ];

    $scope.setNotificationType = function (type, defaultLabelName, preventRead) {
        $scope.filter.type = type;
        if (type === $scope.notificationTypesEnum.All) {
            $scope.selectedTypeName = PUtill.getText('Type');

        } else {
            $scope.selectedTypeName = PUtill.getText(defaultLabelName || $scope.notificationTypesEnum[type]);
        }
        if (!preventRead) {
            $scope.readData();
        }
    };

    $scope.setNotificationStatus = function (status, defaultLabelName, preventRead) {
        $scope.filter.status = status;
        if (status === $scope.notificationTypesEnum.All) {
            $scope.selectedStatusName = PUtill.getText('Status');
        } else {
            $scope.selectedStatusName = PUtill.getText(defaultLabelName || $scope.notificationStatusEnum[status]);
        }
        if (!preventRead) {
            $scope.readData();
        }
    };

    var getSort = function () {
        var sort = new Array();
        $scope.columns.forEach(function (elem) {
            if (elem.isVisible($scope.filter.status) && elem.isSortable && elem.sortCriteria) {
                var sortField = elem.orderByField ? elem.orderByField : elem.field;
                sort.push(new Sort(sortField, elem.sortCriteria));
            }
        });
        return sort.map(function (el) { return '' + el.propertyName + '|' + el.direction }).join(',');
    };

    let getSearchParams = function () {
        return {
            searchString: $scope.filter.search,
            fromDate: $scope.dateRange.dateFrom,
            toDate: PUtill.addDay($scope.dateRange.dateTo),
            status: $scope.filter.status,
            type: $scope.filter.type,
            sort: getSort()
        };
    };

    $scope.clearSearch = function() {
        $scope.filter.search = '';
        $scope.readData();
    };

    $scope.sortBy = function (header) {
        var column = $scope.columns.find(function(item) {
            return item.header === header;
        });

        if (!column.isSortable) {
            return;
        }

        if (!column.sortCriteria || column.sortCriteria === 'Desc') {
            column.sortCriteria = 'Asc';
        } else {
            column.sortCriteria = 'Desc';
        }

        $scope.readData();
    };

    $scope.readData = function () {
        $scope.notifications = $scope.paginator(function (options, callback) {
           return Notifications.query(options, function (result) {
                callback();
                if ($scope.notifications.items.length > 0) {
                    $scope.selectNotification(0);
                }
                $scope.wasSearching = $scope.filter.search;
            });
        }, getSearchParams(), 20);
    };

    $scope.handle = function (id) {

        $scope.yesCancel(
            gettextCatalog.getString(gettext('Handle notification')), gettextCatalog.getString(
                gettext('Do you want to handle this notification?')),
            function() {
                $http.post("api/v1/notifications/"+id+"/handle")
                    .then(function(result) {
                        $scope.readData();
                    });
            });
    };

    $scope.selectNotification = function(indexOfNotification) {
        $scope.selectedNotification = $scope.notifications.items[indexOfNotification];

        $scope.detailsMinHeight = getElementHeight("notificationsBody");
    };

    function getElementHeight(elemId) {
        var el = document.getElementById(elemId);
        return el ? el.offsetHeight : 0;
    }

    $scope.modifyDetails = function(details, type) {
        if (type === $scope.notificationTypesEnum.Test) {
            return details;
        }

        return details;
    };

    function init() {
        $scope.filter = {};
        
        if ($routeParams.type) {
            $scope.setNotificationType($routeParams.type, $scope.notificationTypesEnum[$routeParams.type], true);
        } else {
            $scope.setNotificationType("All", "Type", true);
        }
        $scope.setNotificationStatus("Unhandled", $scope.notificationStatusEnum.Unhandled, true);

        $scope.notificationTypesArray = enumToArray($scope.notificationTypesEnum);
        $scope.notificationStatusArray = enumToArray($scope.notificationStatusEnum);
        $scope.readData();
    }

    function enumToArray(obj) {
        var array = new Array();
        for (var key in obj) {
            array.push({
                key: key,
                value: obj[key]
            });
        }
        return array;
    }

    init();
};
NotificationsController.$inject = ['$scope', 'Notifications', '$http', 'PUtill', 'gettextCatalog', 'gettext',
    '$routeParams', 'DatepickerUtils'];
